import { Utils, NamedEventManager } from "../common";
import { styleTopicName } from "../services";
export class MDComponent extends HTMLElement {
  constructor() {
    super(...arguments);
    this.uid = Math.floor(Math.random() * 1000000);
    this.attributeChangedEventManager = new NamedEventManager();
  }
  async connectedCallback() {
    if (this.container) {
      console.warn("[MDComponent] connectedCallback called with existing container.");
      return;
    }
    // This is used to listen for new CSS to load (only applies to the shadow DOM)
    this.consumerClient = this.singletons.mailBox.buildConsumerClient(`component-${this.elementConfiguration.elementName}-${this.uid}`);
    // Wait for any required tokens
    await this.singletons.tokenService.waitOn(this.elementConfiguration.requireTokenBeforeLoad);
    // Build the container to load our components into
    this.buildContainer();
    // Load styles
    this.loadCss();
    // Publish to the ready topic now so it's ready for the application after the
    // required Javascript loads
    this.publishConnectedMessage();
    // Load Javascript
    this.loadJavascript();
  }
  disconnectedCallback() {
    var _a;
    (_a = this.consumerClient) === null || _a === void 0 ? void 0 : _a.destroy();
    this.attributeChangedEventManager.destroy();
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.attributeChangedEventManager.notify(name, newValue, oldValue);
  }
  buildContainer() {
    if (this.container) {
      console.warn(`[MDComponent] Attempting to build a container when one already exists`);
      return;
    }
    this.container = document.createElement("div");
    if (this.elementConfiguration.useShadowDOM) {
      this.attachShadow({
        mode: "open"
      });
      this.shadowRoot.appendChild(this.container);
    } else {
      this.appendChild(this.container);
    }
    return this.container;
  }
  get rootElement() {
    return this.shadowRoot || this;
  }
  loadCss() {
    // TODO: Revamp this entire logic, it's pretty clunky
    var _a, _b, _c, _d;
    if (!this.elementConfiguration.useShadowDOM) {
      this.singletons.styleRepository.beginGloballyAppending(this.elementConfiguration.elementName);
      if (((_a = this.registrationOptions) === null || _a === void 0 ? void 0 : _a.skipAssetLoading) !== true) {
        // TODO: Make sure the same CSS files are only loaded once in case this element is loaded multiple times
        this.elementConfiguration.css.forEach(cssFile => Utils.loadStyle(cssFile, document.head));
      }
    } else {
      (_b = this.consumerClient) === null || _b === void 0 ? void 0 : _b.subscribeToTopic(styleTopicName(false), (_, __, popAll) => popAll().forEach(e => Utils.appendStyleElement(e, this.rootElement)), true);
      (_c = this.consumerClient) === null || _c === void 0 ? void 0 : _c.subscribeToTopic(styleTopicName(this.elementConfiguration.elementName), (_, __, popAll) => popAll().forEach(e => Utils.appendStyleElement(e, this.rootElement)), true);
      // If asset loading hasn't been skipped, then load the specified CSS files too.
      if (((_d = this.registrationOptions) === null || _d === void 0 ? void 0 : _d.skipAssetLoading) !== true) {
        [...(this.elementConfiguration.useShadowDOM ? this.configuration.autoLoadCss : []), ...this.elementConfiguration.css].forEach(cssFile => {
          Utils.loadStyle(cssFile, this.rootElement);
        });
      }
    }
  }
  loadJavascript() {
    var _a;
    if (((_a = this.registrationOptions) === null || _a === void 0 ? void 0 : _a.skipAssetLoading) === true) {
      return;
    }
    this.elementConfiguration.javascript.forEach(js => Utils.loadScript(js, this.elementConfiguration.elementName));
  }
  async publishConnectedMessage() {
    var _a;
    const mailBox = (_a = window === null || window === void 0 ? void 0 : window.MD) === null || _a === void 0 ? void 0 : _a.mailBox;
    if (!mailBox) {
      throw new Error(`[MDComponent] Mailbox not available at critical time`);
    }
    mailBox.publish(this.elementConfiguration.readyTopic, async integrationInterface => {
      this.mountedInstance = integrationInterface.mountToElement(this.container, {
        mdComponent: this,
        applicationContext: this.applicationContext,
        attributeChangedEventManager: this.attributeChangedEventManager
      });
      this.extraConnectedLogic(integrationInterface);
    });
  }
  extraConnectedLogic(integrationInterface) {}
  get registrationOptions() {
    return this.applicationContext.registrationOptions;
  }
  get configuration() {
    return this.applicationContext.configuration;
  }
  get singletons() {
    return this.applicationContext.singletons;
  }
}